import { Button, Icon } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useLottiePlayer } from 'hooks/common/useLottiePlayer';
import { useEffect, useState } from 'react';
import { Product } from 'types/model';

const TimeBuffPromotion = () => {
  const { open, close, sheets } = useBottomSheet();
  const [product, setProduct] = useState<Product | null>(null);
  const sheet = sheets.TimeBuffPromotion;
  const { playerRef } = useLottiePlayer({ autoplay: true, loop: true, speed: 1 });

  useEffect(() => {
    setProduct(TimeBuffManager.getDiscountProduct(0) ?? null);

    PurchaseManager.attach(function (err: any, coin: any, productId: string) {
      if (!err && productId.includes('timebuff')) {
        close(sheet.id);
        open('TimeBuffPurchaseComplete');
      }
    });

    return () => {
      PurchaseManager.detach();
    };
  }, [close, open, sheet.id]);

  const purchase = () => {
    if (!product) return;

    PurchaseManager.buyCoin(product.productId);
    TimeBuffLogger.logPurchase('clickQuantity', product.productId);
  };

  return (
    <div className="flex h-full w-full flex-col items-center">
      <div className="flex h-[56px] w-full">
        <Icon name="icon/ic_close.svg" onClick={() => close(sheet.id, { skipConfirm: false })} color="filter-base-ic-white" />
      </div>
      <div className="flex h-full w-full flex-col items-center gap-1">
        <div className="text-center text-[56px] font-bold leading-[62px] text-[#FF4390]" dangerouslySetInnerHTML={{ __html: brsc.coin_trial }} />
        <div className="mt-4">{brsc.time_buff_popup_3}</div>
        <div
          className="mt-8 flex max-w-[50%] flex-col items-center justify-center rounded-lg p-6 text-white"
          style={{ background: 'linear-gradient(180deg, #FFADCF 0%, #FF4390 100%)' }}
        >
          <div className="typography-title-lg">{brsc.time_buff}</div>
          <div className="flex h-[66px] w-full items-center justify-center py-2">
            <lottie-player ref={playerRef} src="/imgweb/lottie/time_buff_infinity.json" style={{ width: '80%' }} />
          </div>
          {product && (
            <div className="flex w-fit flex-row gap-2">
              <div className="diagonal-text relative inline-block h-fit w-fit typography-body-sm opacity-70">
                {PageShop.numberToCurrencyString(product.originalPrice, product.price_currency_code)}
              </div>
              <div className="typography-headline-lg">{PageShop.numberToCurrencyString(product.price, product.price_currency_code)}</div>
            </div>
          )}
        </div>
        <div className="mt-auto" />
        <div className="flex w-full flex-col justify-start gap-2 pb-2 text-white">
          <div className="typography-title-md">Check Point</div>
          <CheckPoint text={brsc.time_buff_sub_4} />
          <CheckPoint text={brsc.time_buff_sub_5.replace('$param', '14')} />
        </div>
        <Button onClick={purchase} style={{ text: brsc.purchase, color: 'white', fontColor: 'black' }} className="w-full" />
      </div>
    </div>
  );
};

const CheckPoint = ({ text }: { text: string }) => {
  return (
    <div className="flex gap-1">
      <img alt="" src="/imgweb/icon/ic_check_circle.svg" />
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

export default TimeBuffPromotion;
